"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVBTypography = require("@svb/svb-react-components/dist/components/SVBTypography");
var _svbReactComponents = require("@svb/svb-react-components");
var _Error = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Error.svg"));
var _List = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/List.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable */

/*
 * SVB Error State
 * Author by Prashant Bhatt <pbhatt@svb.com> (www.svb.com)
 * SVBErrorState classes="serverError" stateType="refresh" headline="Unknown Error" tagline="This is an example of a tagline" refreshParent={refreshParent} />
 */

/**
 * SVBErrorState
 * Required Parameters
 * @param stateType: applies styles based on this prop options: 1) refresh 2) support 3) no result
 * see ../readme.MD for full  description
 * @param headline: Headline/ Title for the Error state
 * see ../readme.MD for full  description
 * @param tagline: Description for the Error state
 * Optional Parameters
 * @param supportTagline: Used in support stateType for Additional Description for the Error state
 * see ../readme.MD for full  description
 * @param link: Used in support stateType for support link
 * see ../readme.MD for full  description
 * @param linkText: Text displayed for support link
 * see ../readme.MD for full  description
 * @param classes: additional styling classes
 * see ../readme.MD for full  description
 * @param refreshParent: refresh callback function to parent
 * see ../readme.MD for full  description
 * @returns SVB Error State component
 */

const SVBErrorState = _ref => {
  let {
    stateType,
    refreshParent,
    headline,
    tagline,
    supportTagline,
    linkText,
    link,
    classes
  } = _ref;
  //triggers refreshing page or parent component
  const triggerRefresh = (e, item) => {
    if (typeof item == 'undefined') {
      //if no parent callback refreshes the whole page on click
      // window.location.reload();
    } else {
      refreshParent();
    }
  };
  const refreshElement = () => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      src: _Error.default,
      alt: "error-icon",
      className: "error-icon"
    }), /*#__PURE__*/_react.default.createElement(_SVBTypography.SVBTypography, {
      type: "sub-heading-large",
      variant: "medium"
    }, headline ? headline : 'Unknown Error'), tagline && /*#__PURE__*/_react.default.createElement(_SVBTypography.SVBTypography, {
      type: "paragraph",
      variant: "small"
    }, ' ', tagline, ' '), /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBButton, {
      extraClasses: "error-state-refresh",
      text: "Refresh",
      size: "large",
      style: "text",
      state: "default",
      type: "text",
      icon: "fa fa-rotate-right",
      iconSide: "left",
      onClick: e => triggerRefresh(e, refreshParent)
    }));
  };
  function supportElement() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      src: _Error.default,
      alt: "error-icon",
      className: "error-icon"
    }), /*#__PURE__*/_react.default.createElement(_SVBTypography.SVBTypography, {
      type: "sub-heading-large",
      variant: "medium"
    }, headline ? headline : 'Unknown Error'), tagline && /*#__PURE__*/_react.default.createElement(_SVBTypography.SVBTypography, {
      type: "paragraph",
      variant: "small"
    }, ' ', tagline), /*#__PURE__*/_react.default.createElement(_SVBTypography.SVBTypography, {
      type: "paragraph",
      variant: "small"
    }, supportTagline ? supportTagline : 'Check the URL or contact', /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("a", {
      className: "support-link",
      href: link ? link : '/contact',
      target: "_blank"
    }, linkText ? linkText : 'Customer Service'))));
  }
  const noresultElement = () => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      src: _List.default,
      alt: "error-icon",
      className: "error-icon"
    }), /*#__PURE__*/_react.default.createElement(_SVBTypography.SVBTypography, {
      type: "sub-heading-large",
      variant: "medium"
    }, headline ? headline : 'Empty Result'), tagline && /*#__PURE__*/_react.default.createElement(_SVBTypography.SVBTypography, {
      type: "paragraph",
      variant: "small"
    }, tagline));
  };
  const elementClass = classes ? 'svb-error-state ' + classes : 'svb-error-state';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: elementClass
  }, stateType == 'refresh' && refreshElement(), stateType === 'support' && supportElement(), stateType === 'noresult' && noresultElement());
};
var _default = exports.default = SVBErrorState;